<template>
  <base-modal
    ref="modal"
    :image="require('../../../../images/modal/add-company-infographics.svg')"
    :scrollable="true"
    :show-close-button="false"
    size="small"
    :title="title"
    @submit="updateCompany"
  >
    <template #content>
      <company-form
        :errors="form.errors"
        :form="form"
        @update-form="updateForm"
      />
    </template>
    <template #actions>
      <div class="container">
        <div class="row d-flex justify-content-sm-between align-content-center">
          <div class="column">
            <div class="row">
              <base-button
                size="xl"
                @click.prevent="modal.close"
              >
                Cancel
              </base-button>
              <primary-button
                size="xl"
                @click="updateCompany"
              >
                Save
              </primary-button>
            </div>
          </div>
        </div>
      </div>
    </template>
  </base-modal>
</template>

<script>
import { Form } from "@/classes/form"
import Language from "../../../i18n/en"
import { CompanyRoutes } from "../../../api/routes"
import CompanyForm from "@/components/company/CompanyForm.vue"

export default {
  components: {
    CompanyForm
  },
  props: {
    company: {
      type: Object,
      default: null
    },
    title: {
      type: String,
      default: "Add Company"
    },
    action: {
      type: Function,
      default: null
    }
  },
  data () {
    return {
      modal: {
        close: () => {}
      },
      companyId: null,
      form: new Form({
        name: "",
        company_street: "",
        company_street_number: "",
        company_city: "",
        company_postal: "",
        company_country: "",
        company_vat: "",
        pricing_package: "",
        cpm_price: 0,
        impression_target: 0
      })
    }
  },
  mounted () {
    this.modal = this.$refs.modal

    if (this.company) {
      this.form.name = this.company.name
      this.form.pricing_package = this.company.pricing_package
      this.form.company_street = this.company.company_street
      this.form.company_street_number = this.company.company_street_number
      this.form.company_city = this.company.company_city
      this.form.company_postal = this.company.company_postal
      this.form.company_country = this.company.company_country
      this.form.company_vat = this.company.company_vat
      this.form.cpm_price = this.company.cpm_price
      this.form.impression_target = this.company.impression_target
    }
  },
  methods: {
    clearErrorsName () {
      this.form.errors.errors.name = []
    },
    updateForm (value) {
      this.form[value.property] = value.value
    },
    updateCompany () {
      return this.form
        .put(CompanyRoutes.updateCompanyDetails(this.company.uuid))
        .then(this.onSuccess)
        .catch(() => {
          this.$toasted.error(Language.company.error.edit)
        })
    },
    onSuccess () {
      this.$toasted.success(Language.company.success.edit)
      this.modal.close()
      if (this.action) {
        this.action()
      }
    }
  }
}
</script>
